import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";

@Component({
    selector: 'number-dialog',
    templateUrl: 'number-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule]
})
  export class NumberDialogComponent {

    constructor(
      public dialogRef: MatDialogRef<NumberDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: {amount: number, label: string},
      
    ) {}
  
    onNoClick(): void {
      //this.dialogRef.
      this.dialogRef.close();
    }
  }